import { makeObservable, observable, action, computed } from 'mobx'
import axios from 'axios'
import { BaseStore } from './BaseStore'
import type { Guest } from '@core/models'

export class GuestStore extends BaseStore {
  guests: Map<string, Guest> = new Map()
  currentGuest: Guest | null = null

  constructor() {
    super()
    makeObservable(this, {
      guests: observable,
      currentGuest: observable,
      getGuests: action,
      getGuest: action,
      updateGuest: action,
      guestsArray: computed
    })
  }

  async getGuests(tenantId: string) {
    const result = await this.handleApiCall(async () => {
      const response = await axios.get<Guest[]>(
        this.apiPath(`v1/tenants/${tenantId}/guests`),
        { headers: this.generateFetchHeader() }
      )
      return response.data
    })

    if (result) {
      this.guests.clear()
      result.forEach(guest => {
        this.guests.set(guest.id, guest)
      })
      return true
    }
    return false
  }

  async getGuest(tenantId: string, guestId: string) {
    const result = await this.handleApiCall(async () => {
      const response = await axios.get<Guest>(
        this.apiPath(`v1/tenants/${tenantId}/guests/${guestId}`),
        { headers: this.generateFetchHeader() }
      )
      return response.data
    })

    if (result) {
      this.currentGuest = result
      this.guests.set(result.id, result)
      return true
    }
    return false
  }

  async updateGuest(tenantId: string, guestId: string, data: Partial<Guest>) {
    const result = await this.handleApiCall(async () => {
      await axios.put(
        this.apiPath(`v1/tenants/${tenantId}/guests/${guestId}`),
        data,
        { headers: this.generateFetchHeader() }
      )
      return true
    })

    if (result) {
      // 更新されたゲスト情報を再取得
      await this.getGuest(tenantId, guestId)
      this.tryShowToast('ゲスト情報を更新しました', 'success')
      return true
    }

    this.tryShowToast('ゲスト情報の更新に失敗しました', 'error')
    return false
  }

  get guestsArray() {
    return Array.from(this.guests.values())
  }
}